// extracted by mini-css-extract-plugin
export default {"dialogContent":"ProgramDetailsDialog_dialogContent__WXMBt","dialogPaper":"ProgramDetailsDialog_dialogPaper__soDVS","footer":"ProgramDetailsDialog_footer__onwZl"};